<div (click)="openModal()">
  @if (customBody) {
    <ng-content></ng-content>
  } @else {
    <button
      class="d-flex align-items-center"
      ngbDropdownItem
      title="{{ buttonTitle | translate }}"
      type="button"
    >
      <svg
        class="icon-size-res"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <use [attr.href]="buttonIcon"></use>
      </svg>
      <span class="fs-base-l0 ms-2">{{
        buttonTitle | translate
      }}</span>
    </button>
  }
</div>

<ng-template #defaultBody>
  <button
    class="d-flex align-items-center"
    ngbDropdownItem
    title="{{ buttonTitle | translate }}"
    type="button"
  >
    <svg
      class="icon-size-res"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <use [attr.href]="buttonIcon"></use>
    </svg>
    <span class="fs-base-l0 ms-2">{{ buttonTitle | translate }}</span>
  </button>
</ng-template>

<ng-template #modalTemp>
  <app-modal-confirmation-std-mobile-header
    class="h-100"
    [dismissText]="'COMMON.Cancel' | translate"
    [header]="buttonTitle | translate"
    [submitText]="'COMMON.Confirm' | translate"
    [isSubmitDisabled]="isDisableFolder"
    [isLoading]="loading"
    (dismiss)="closeModal()"
    (submitted)="confirm()"
  >
    <ng-template>
      @if (formerLocation) {
        <div class="d-flex align-items-center pb-base-u0">
          <span
            >{{
              'FOLDERS.MOVE-TO-FOLDER.CURRENT-LOCATION' | translate
            }}:</span
          >
          <div
            class="ms-3 container-folder pointer py-base-l10 px-base-l10 px-base-md-u0"
            (click)="navigateFolder(formerLocation.id)"
          >
            <svg class="icon-btn-svg" stroke="currentColor">
              <use
                href="assets/images/icons/files/folder.svg#folder"
                height="16"
                width="16"
              ></use>
            </svg>
            {{ formerLocation.name }}
          </div>
        </div>
      }
      <div
        class="d-flex flex-nowrap align-items-center justify-content-between justify-content-md-end"
      >
        <div class="col-auto col-md p-0">
          @if (currentFolderDetail?.paths?.length) {
            @if (currentFolderDetail?.paths?.length) {
              <app-folder-paths
                [paths]="currentFolderDetail?.paths || []"
                (clickPath)="navigateFolder($event)"
              ></app-folder-paths>
            }
          } @else if (!hasNoFolderToSelect) {
            <div>
              {{
                'FOLDERS.MOVE-TO-FOLDER.PLEASE-SELECT-FOLDER'
                  | translate
              }}
            </div>
          }
        </div>
        <div
          class="col col-md-auto row gx-2 flex-nowrap align-items-center justify-content-end"
        >
          @if (!this.filters.folder) {
            <app-list-view-toggle
              class="col-auto"
              (selectedChange)="selectLayoutView($event)"
              [selected]="layOutView"
            >
            </app-list-view-toggle>
          }
        </div>
      </div>
      <div
        class="container-folders"
        [ngClass]="{ empty: !folderItemRes?.count }"
        appScrollTracker
        (scrollingFinished)="loadMore()"
      >
        @if (!loading || folderItemRes?.results?.length) {
          <ng-container
            *ngTemplateOutlet="
              folderItemRes?.count
                ? layOutView === 'grid_view'
                  ? gridView
                  : listView
                : emptyContent
            "
          >
          </ng-container>
          <ng-template #gridView>
            <div class="grid-view pt-base-u0 px-base-l10">
              @for (
                folderItem of folderItemRes?.results;
                track folderItem;
                let i = $index
              ) {
                <app-grid-view-card
                  [class.disabled]="
                    folderItem.type !== 'folder' ||
                    folderItem.id === itemId
                  "
                  [disabled]="
                    folderItem.type !== 'folder' ||
                    folderItem.id === itemId
                  "
                  (clickCard)="onClickFolderItem(folderItem)"
                  [hasCheck]="false"
                  [isSelectedCard]="
                    folderItem.id === selectedFolder?.id
                  "
                  (dblclick)="
                    onClickFolderItem(folderItem); confirm()
                  "
                  [thumbnailHeight]="
                    this.deviceType === 'desktop' ? 150 : 100
                  "
                >
                  <ng-template appCardThumbnail>
                    <div
                      class="folder-icon round-input bg d-flex flex-column align-items-center justify-content-center"
                    >
                      <div class="icon">
                        <svg height="55" width="55">
                          <use
                            height="55"
                            width="55"
                            href="assets/images/pictograms/open-folder-blue.svg#open-folder-blue"
                          ></use>
                        </svg>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template appCardDetail>
                    <div class="card-detail">
                      <div class="d-flex align-items-center">
                        <div class="col my-2 overflow-hidden">
                          <label
                            class="d-block fw-semibold text-truncate"
                          >
                            {{
                              $any(folderItem.item_detail).name || '-'
                            }}
                          </label>
                          <label
                            class="d-block subtext mb-0 text-normal text-gray-neutrals fs-l6"
                          >
                            {{
                              $any(folderItem.item_detail).item_count
                            }}
                            Files
                          </label>
                        </div>
                      </div>
                      <app-folder-share-with-display
                        *appFeatureFlag="'share_folder_enable'"
                        [folder]="$any(folderItem.item_detail)"
                      >
                      </app-folder-share-with-display>
                    </div>
                  </ng-template>
                </app-grid-view-card>
              }
            </div>
          </ng-template>
          <ng-template #listView>
            <div class="table-panel p-0">
              <div class="table-panel-body">
                <p-table
                  class="d-table w-100 m-0 p-datatable-wrapper"
                  [tableStyleClass]="'table-v4'"
                  [resizableColumns]="false"
                  responsiveLayout="scroll"
                  [value]="folderItemRes?.results || []"
                >
                  <ng-template pTemplate="header">
                    <tr class="table-header">
                      <th>
                        <span>
                          {{ 'FOLDERS.FILE-NAME' | translate }}
                        </span>
                      </th>
                      <th class="th-imported-by">
                        <span>
                          {{ 'FOLDERS.CREATED-BY' | translate }}
                        </span>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-item>
                    <tr
                      [class.tr-selected]="
                        item.id === selectedFolder?.id
                      "
                      [class.tr-disabled]="
                        item.type !== 'folder' || item.id === itemId
                      "
                      (click)="onClickFolderItem(item)"
                    >
                      <ng-container
                        [ngTemplateOutlet]="
                          item.type === 'folder'
                            ? folderTableBody
                            : memoTableBody
                        "
                        [ngTemplateOutletContext]="{
                          item: item,
                          item_detail: item.item_detail,
                        }"
                      >
                        <ng-template
                          #folderTableBody
                          let-item="item"
                          let-item_detail="item_detail"
                        >
                          <td class="text-muted v-middle">
                            <div class="d-flex align-items-center">
                              <app-file-icon
                                [extension]="'folder'"
                              ></app-file-icon>
                              <div class="ps-2">
                                <a class="title-text">
                                  {{ item_detail.name }}
                                </a>
                                <p
                                  class="text-muted mb-0 fs-subtitle fw-400 mt-1"
                                >
                                  {{ item_detail.item_count }} Files
                                </p>
                              </div>
                            </div>
                          </td>
                          <td class="v-middle">
                            <a class="title-text">
                              {{
                                item_detail.created_user?.full_name
                              }}
                            </a>
                            <p
                              class="text-muted mb-0 fs-subtitle fw-400 mt-1"
                            >
                              {{
                                item_detail.created_at
                                  | date: 'dd/MM/yyyy'
                              }}
                            </p>
                          </td>
                        </ng-template>
                        <ng-template
                          #memoTableBody
                          let-item="item"
                          let-item_detail="item_detail"
                        >
                          <td class="text-muted v-middle">
                            <div class="d-flex align-items-center">
                              @if (item.type === 'memo') {
                                <app-file-icon
                                  [extension]="'memo'"
                                ></app-file-icon>
                                <div class="ps-2">
                                  <a class="title-text">
                                    {{
                                      item_detail.subject ||
                                        ('MEMOS.UNTITLED' | translate)
                                    }}
                                  </a>
                                  <p
                                    class="text-muted mb-0 fs-subtitle fw-400 mt-1"
                                  >
                                    {{
                                      item_detail.memo_number
                                        ? item_detail.memo_number
                                        : '-'
                                    }}
                                  </p>
                                </div>
                              } @else {
                                @if (item_detail.thumbnail_img) {
                                  <img
                                    [src]="
                                      item_detail.thumbnail_img
                                        | secure
                                        | async
                                    "
                                    width="28"
                                    height="32"
                                    class="border"
                                  />
                                } @else {
                                  @if (
                                    ['jpg', 'jpeg', 'png'].includes(
                                      item_detail.file_name
                                        | urlToExtension
                                    )
                                  ) {
                                    <img
                                      [src]="
                                        item_detail.file
                                          | secure
                                          | async
                                      "
                                      width="28"
                                      class="border"
                                    />
                                  } @else {
                                    <app-file-icon
                                      [extension]="
                                        $any(
                                          item_detail.file_name
                                            | urlToExtension
                                        )
                                      "
                                    />
                                  }
                                }
                                <div class="ps-2">
                                  <a class="title-text">
                                    {{ item_detail.file_name }}
                                  </a>
                                  <p
                                    class="text-muted mb-0 fs-subtitle fw-400 mt-1"
                                  >
                                    {{
                                      (item_detail.file_size /
                                        (1024 * 1024)
                                        | number: '1.2-2') + ' mb'
                                    }}
                                  </p>
                                </div>
                              }
                            </div>
                          </td>
                          <td class="v-middle">
                            <a class="title-text">
                              {{
                                item_detail.created_user?.full_name
                              }}
                            </a>
                            <p
                              class="text-muted mb-0 fs-subtitle fw-400 mt-1"
                            >
                              {{
                                item_detail.created_at
                                  | date: 'dd/MM/yyyy'
                              }}
                            </p>
                          </td>
                        </ng-template>
                      </ng-container>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </ng-template>
          <ng-template #emptyContent>
            <div class="content-empty">
              <svg
                class="icon-empty-page"
                height="150"
                viewBox="0 0 380 150"
                width="80%"
              >
                <use
                  href="assets/images/pictograms/paint.svg#paint"
                  height="124"
                  width="375"
                  y="8"
                  fill="#EAEAED"
                ></use>
                <use
                  href="assets/images/pictograms/open-folder.svg#open-folder"
                  height="140"
                  width="120"
                  x="127"
                ></use>
              </svg>
              <label class="h4 fw-bold mb-1">
                @if (hasNoFolderToSelect) {
                  <span>{{
                    'FOLDERS.MOVE-TO-FOLDER.NO-FOLDER-TO-SELECT'
                      | translate
                  }}</span>
                } @else {
                  <span>{{
                    'FOLDERS.EMPTY-CONTENT.Empty folder!' | translate
                  }}</span>
                }
              </label>
              @if (hasNoFolderToSelect) {
                <label class="text-gray-neutrals">
                  {{
                    'FOLDERS.MOVE-TO-FOLDER.CREATE-FOLDER-FIRST'
                      | translate
                  }}
                </label>
              }
            </div>
          </ng-template>
        }
      </div>
    </ng-template>
  </app-modal-confirmation-std-mobile-header>
</ng-template>
